import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Body from "../../components/Body/Body";

const Main = () => {
	return (
		<>
			<Navbar></Navbar>
			<Body></Body>
		</>
	);
};

export default Main;
